export default function defineTitreIntervenant(intervenant, i18n) {
  const tabLibelleTitreIntervenant = [];
  tabLibelleTitreIntervenant.push(i18n.t('editionFacture.clients.advertiser'));
  tabLibelleTitreIntervenant.push(i18n.t('editionFacture.clients.mandatairePayeur'));
  tabLibelleTitreIntervenant.push(i18n.t('editionFacture.clients.mandataireNonPayeur'));
  tabLibelleTitreIntervenant.push(i18n.t('editionFacture.clients.originator'));

  if (intervenant.titre !== null && tabLibelleTitreIntervenant.some((libelle) => {
    return intervenant.titre === libelle;
  })) {
    intervenant.titre = null;
  }
  if (intervenant.titre) {
    return;
  }

  if (intervenant.annonceur) {
    intervenant.titre = i18n.t('editionFacture.clients.advertiser');
    return;
  }

  if (intervenant.mandataire) {
    if (intervenant.payeur) {
      intervenant.titre = i18n.t('editionFacture.clients.mandatairePayeur');
    } else {
      intervenant.titre = i18n.t('editionFacture.clients.mandataireNonPayeur');
    }
    return;
  }

  if (intervenant.donneurOrdre) {
    intervenant.titre = i18n.t('editionFacture.clients.originator');
  }
}
